import { render, staticRenderFns } from "./PackageModule.html?vue&type=template&id=0b367182&scoped=true&"
import script from "./PackageModule.vue?vue&type=script&lang=js&"
export * from "./PackageModule.vue?vue&type=script&lang=js&"
import style0 from "./PackageModule.vue?vue&type=style&index=0&id=0b367182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b367182",
  null
  
)

export default component.exports